/** The prototype showed the same reviews on every product. */
export const DEFAULT_REVIEWS = [
  {
    id: 'r1',
    who: 'Priya S.',
    stars: '★★★★★',
    text: 'Arrived beautifully packed with a little handwritten note. Quality is even better than the photos.',
  },
  {
    id: 'r2',
    who: 'Arjun M.',
    stars: '★★★★☆',
    text: 'Really happy with this. Shipping took a day longer than estimated but totally worth the wait.',
  },
  {
    id: 'r3',
    who: 'Neha K.',
    stars: '★★★★★',
    text: 'Bought one as a gift, then immediately ordered another for myself. No regrets.',
  },
];
